import axios from '@/utils/http';

export default ({
  emergency = '',
  emergency_number = '',
  emergency_relationship = '',
}) => {
  return axios
    .post('/landun', {
      emergency,
      emergency_number,
      emergency_relationship,
    })
    .then(data => Promise.resolve(data.data))
    .catch(err => Promise.reject(err));
};
